export const SITE = {
  brand: "Online-Bewertungsmanagement",
  brandShort: "OBM",
  tagline: "Professionelles Reputationsmanagement",
  phone: "+49 172 5263514",
  phoneRaw: "+491725263514",
  email: "info@femmesmarketing.com",
  whatsapp: "https://wa.me/message/OFN5FHUN2OVSJ1",
  sister: {
    in7: "https://in7sekunden.de/",
    femmes: "https://www.femmesonlinebusiness.com/",
  },
  legal: {
    name: "Petra Osterode",
    street: "Dubliner Str. 17",
    city: "30982 Pattensen",
    phone: "01725263514",
    fax: "051019904079",
    email: "info@femmesmarketing.com",
    stnr: "23/132/05155",
    role: "Digital Marketer",
  }
};
